import { defineMessages } from 'react-intl';

const scope = 'dashboard.app';

const messages = defineMessages({
  appBarIconButton: {
    id: `${scope}.AppBar.IconButton`,
    defaultMessage: '더 보기',
  },
  appBarPathsSchoolNewsletters: {
    id: `${scope}.AppBar.paths.schoolNewsletters`,
    defaultMessage: '가정통신문',
  },
  appBarPathsOutbox: {
    id: `${scope}.AppBar.paths.outbox`,
    defaultMessage: '임시보관함',
  },
  appBarPathsNewsletter: {
    id: `${scope}.AppBar.paths.newsletter`,
    defaultMessage: '가정통신문 상세',
  },
  appBarPathsWriting: {
    id: `${scope}.AppBar.paths.writing`,
    defaultMessage: '가정통신문 작성',
  },
  appBarPathsContacts: {
    id: `${scope}.AppBar.paths.contacts`,
    defaultMessage: '주소록',
  },
  appBarPathsNew: {
    id: `${scope}.AppBar.paths.new`,
    defaultMessage: '연락처 추가',
  },
  appBarUserName: {
    id: `${scope}.AppBar.UserName`,
    defaultMessage: '{ name } { role }',
  },
  appBarUserNameRoleParent: {
    id: `${scope}.AppBar.UserName.role.parent`,
    defaultMessage: '학부모',
  },
  appBarUserNameRoleStudent: {
    id: `${scope}.AppBar.UserName.role.student`,
    defaultMessage: '학생',
  },
  appBarUserNameRoleTeacher: {
    id: `${scope}.AppBar.UserName.role.teacher`,
    defaultMessage: '선생님',
  },
  breadcrumbHeading: {
    id: `${scope}.Breadcrumb.Heading`,
    defaultMessage: '사용자 내비게이션',
  },
  logoTitle: {
    id: `${scope}.Logo.Title`,
    defaultMessage: 'Classting School',
  },
  navigationHeading: {
    id: `${scope}.Navigation.Heading`,
    defaultMessage: 'Global Navigation',
  },
  navigationMenuItemHome: {
    id: `${scope}.Navigation.MenuItem.home`,
    defaultMessage: '홈',
  },
  navigationMenuItemNewsletters: {
    id: `${scope}.Navigation.MenuItem.newsletters`,
    defaultMessage: '가정통신문',
  },
  navigationMenuItemContacts: {
    id: `${scope}.Navigation.MenuItem.contacts`,
    defaultMessage: '주소록',
  },
  navigationMenuItemLearning: {
    id: `${scope}.Navigation.MenuItem.learning`,
    defaultMessage: '학습분석',
  },
  navigationMenuItemAttendance: {
    id: `${scope}.Navigation.MenuItem.attendance`,
    defaultMessage: '출석부',
  },
  navigationMenuItemSettings: {
    id: `${scope}.Navigation.MenuItem.settings`,
    defaultMessage: '설정',
  },
  navigationMenuItemPayment: {
    id: `${scope}.Navigation.MenuItem.payment`,
    defaultMessage: '결제',
  },
  navigationSubListItemTextLearning: {
    id: `${scope}.Navigation.SubListItemText.learning`,
    defaultMessage: '러닝 리포트',
  },
  navigationSubListItemTextAssignments: {
    id: `${scope}.Navigation.SubListItemText.assignments`,
    defaultMessage: '과제 리포트',
  },
  navigationSubListItemTextAI: {
    id: `${scope}.Navigation.SubListItemText.ai`,
    defaultMessage: 'AI 리포트',
  },
  schoolSelectInputLabel: {
    id: `${scope}.SchoolSelect.InputLabel`,
    defaultMessage: 'School',
  },
});

export default messages;
